import axios from 'axios'
import { handleApiError } from '@/utils/apiHelpers'

export default {
    getRequests({ commit }, payload = {
        paginate: '',
        query: ''}) {
        const paginate = payload.paginate,
            query = payload.query

        commit('GET_REQUESTS_REQUEST')

        return axios
            .get(`/requests/requests${paginate}${query}`)
            .then(response => {
                commit('GET_REQUESTS_SUCCESS', response.data)

                return Promise.resolve(response)
            })
            .catch(error => {
                commit('GET_REQUESTS_FAILURE')
                handleApiError(error, 'Pobranie listy spraw nie powiodło się.')

                return Promise.reject(error)
            })
    },
    getRequest({ commit }, requestId) {
        return axios
            .get(`/requests/requests/${requestId}`)
            .then(response => {
                commit('GET_REQUEST_SUCCESS', response.data)

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, `Pobranie danych do zapotrzebowania ${requestId} nie powiodło się.`)

                return Promise.reject(error)
            })
    },
    createRequest({ commit }, requestData) {
        return axios
            .post('/requests/requests', requestData)
            .then(response => {
                commit('SHOW_NOTIFICATION', {
                    type: 'success',
                    message: 'Zapotrzebowanie zostało dodane.'
                }, {root: true})

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Dodanie zapotrzebowania nie powiodło się.')

                return Promise.reject(error)
            })
    },
    updateRequest({ commit }, requestData) {
        return axios
            .put(`/requests/requests/${requestData.id}`, requestData)
            .then(response => {
                commit('SHOW_NOTIFICATION', {
                    type: 'success',
                    message: 'Zapotrzebowanie zostało zedytowane.'
                }, { root: true })

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Zapis zapotrzebowania nie powiódł się.')

                return Promise.reject(error)
            })
    },
    getRequestTypes({ commit }) {
        return axios
            .get('/requests/requests/dicts/request-types')
            .then(response => {
                commit('GET_REQUEST_TYPES_SUCCESS', response.data.results)

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Pobranie typów zapotrzebowania nie powiodło się.')

                return Promise.reject(error)
            })
    },
    getRequestStatuses({ commit }) {
        return axios
            .get('/requests/requests/dicts/statuses')
            .then(response => {
                commit('GET_REQUEST_STATUSES_SUCCESS', response.data.results)

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Pobranie statusów nie powiodło się.')

                return Promise.reject(error)
            })
    },
    createRequestComment({ commit }, payload) {
        return axios
            .post('/requests/request-comments', payload)
            .then(response => {
                commit('SHOW_NOTIFICATION', {
                    type: 'success',
                    message: 'Dodano komentarz.'
                }, { root: true })

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Dodanie komentarza nie powiodło się.')

                return Promise.reject(error)
            })
    },
    createRequestAttachment(context, formData) {
        return axios
            .post('/requests/requests/uploads', formData)
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Dodanie załącznika nie powiodło się.')

                return Promise.reject(error)
            })
    },
    deleteRequest({ commit }, requestId) {
        return axios
            .delete(`/requests/requests/${requestId}`)
            .then(response => {
                commit('SHOW_NOTIFICATION', {
                    type: 'success',
                    message: 'Zapotrzebowanie zostało usunięte.'
                }, { root: true })

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Usunięcie zapotrzebowania nie powiodło się.')

                return Promise.reject(error)
            })
    },
    deleteRequestAttachment({ commit }, attachmentId) {
        return axios
            .delete(`/requests/requests/uploads/${attachmentId}`)
            .then(response => {
                commit('SHOW_NOTIFICATION', {
                    type: 'success',
                    message: 'Załącznik został usunięty.'
                }, { root: true })

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Usunięcie załącznika nie powiodło się.')

                return Promise.reject(error)
            })
    },
    getRequestStatusHistory(context, requestId) {
        return axios
            .get(`/requests/requests/${requestId}/status-history`)
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Pobranie historii statusów nie powiodło się.')

                return Promise.reject(error)
            })
    },
    getRequestAssignHistory(context, requestId) {
        return axios
            .get(`/requests/requests/${requestId}/assign-history`)
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Pobranie historii przypisań nie powiodło się.')

                return Promise.reject(error)
            })
    },
    createExternalRequest({ commit }, requestData) {
        return axios
            .post('/requests/external-requests', requestData)
            .then(response => {
                commit('SHOW_NOTIFICATION', {
                    type: 'success',
                    message: 'Zapytanie zostało dodane.'
                }, {root: true})

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Dodanie zapytania nie powiodło się.')

                return Promise.reject(error)
            })
    },
    getExternalRequest(context, externalRequestId) {
        return axios
            .get(`/requests/external-requests/${externalRequestId}`)
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, `Pobranie danych do zapytania ${externalRequestId} nie powiodło się.`)

                return Promise.reject(error)
            })
    },
    clearRequestAttachments({ commit }) {
        commit('CLEAR_REQUEST_ATTACHMENTS')
    },
    setRequestFilters({ commit }, filters) {
        commit('SET_REQUEST_FILTERS', filters)
    },
    updateMaterialsList({commit}, material) {
        commit('UPDATE_MATERIALS_LIST', material)
    },
    updateMaterial({commit}, material) {
        commit('UPDATE_MATERIAL', material)
    },
    clearMaterials({commit}) {
        commit('CLEAR_MATERIALS_LIST')
    },
    clearRequestFilters({ commit }) {
        commit('CLEAR_REQUEST_FILTERS')
    },
}